import { Button, Form } from "antd";
import React from "react";
import { InputOTP } from 'antd-input-otp';
const OTPForm = (props) => {
    const { HandleVerifyOTP, handleChange, initialCredential, otpMessage, waiting, timerVisible, countdown, CheckTwoFactor } = props;
    const [form] = Form.useForm();
  return (
    <Form
      layout="vertical"
      name="login-form"
      initialValues={initialCredential}
      onFinish={HandleVerifyOTP}
      form={form}
    >
      <Form.Item
        name="otp"
        label="Enter Your OTP"
        rules={[
          {
            required: true,
            message: "Please enter your otp",
          },
        ]}
      >
        <InputOTP
          autoFocus
          onChange={handleChange}
          inputType="numeric"
          length={6}
          autoSubmit={form}
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          className="mt-3"
          htmlType="submit"
          block
          // disabled={disabled}
          loading={waiting}
        >
          Submit
        </Button>
      </Form.Item>
      <p className="my-3 text-capitalize">{otpMessage}</p>
      {timerVisible ? (
        <div>
          <p className="text-center">Resend OTP in {countdown} seconds</p>
        </div>
      ) : (
        <Button onClick={() => CheckTwoFactor()}>Resend OTP</Button>
      )}
    </Form>
  );
};

export default OTPForm;
